import { seloDoCertificado, type CertificadoParaSelo, type CorDoSelo } from '../../utils/certificateStatus';

const CORES: Record<CorDoSelo, { color: string; background: string }> = {
  verde: { color: 'var(--color-success)', background: 'rgba(34, 197, 94, 0.12)' },
  amarelo: { color: 'var(--color-warning)', background: 'rgba(234, 179, 8, 0.12)' },
  vermelho: { color: 'var(--color-error)', background: 'rgba(239, 68, 68, 0.12)' },
  cinza: { color: 'var(--color-text-secondary)', background: 'rgba(148, 163, 184, 0.12)' },
};

/** Selo de situação: Válido / Vence em N dias / Vence hoje / Vencido / Removido do Lictor. */
export function CertificateStatusBadge({ certificate }: { certificate: CertificadoParaSelo }) {
  const selo = seloDoCertificado(certificate);
  return (
    <span
      style={{
        ...CORES[selo.cor],
        padding: '2px var(--space-3)',
        borderRadius: 'var(--radius-full)',
        fontSize: 'var(--text-xs)',
        fontWeight: 'var(--font-medium)',
        whiteSpace: 'nowrap',
      }}
    >
      {selo.texto}
    </span>
  );
}
